/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-Dm1irIE2.js";
import { t } from "./decorateMetadata-BhwOl-pv.js";
import { t as n } from "./decorate-DHgd5sZx.js";
import { t as r } from "./css-build-DICbZE45.js";
import "./icon-DGn-d_zv.js";
import { FormElement as i } from "./elements/formElement.js";
import { LitElement as a, html as o, nothing as s } from "lit";
import { customElement as c, property as l, query as u, state as d } from "lit/decorators.js";
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/time-input/time-input.css.js
var f = r(":host{--_time-input-spacing:var(--time-input-spacing,.3em);--_time-input-radius:var(--time-input-radius,var(--radius-relative));--_time-input-background:var(--time-input-background,var(--color-bg));--_time-input-cursor:text;align-items:center;gap:var(--_time-input-spacing);width:min-content;color:var(--time-input-color,currentColor);cursor:var(--_time-input-cursor);border:solid 1px var(--time-input-border-color,var(--shade-2));border-radius:var(--_time-input-radius);background:var(--_time-input-background);outline:0 solid var(--time-input-outline-color,var(--primary));outline-offset:-1px;padding:var(--_time-input-spacing);box-sizing:border-box;justify-content:space-between;line-height:1.55rem;display:inline-flex;position:relative}:host([compact]){line-height:normal}:host([disabled]){pointer-events:none}:host([readonly]){--_time-input-cursor:pointer}:host([readonly]:focus-within){outline-width:0}:host(:hover:not(:focus-within)){background-color:color-mix(in srgb, currentColor 20%, var(--_time-input-background))}:host(:focus-within){outline-width:1px}input{appearance:none;text-align:center;font-variant-numeric:tabular-nums lining-nums;letter-spacing:.05em;width:5.85ex;color:inherit;box-sizing:border-box;font:inherit;cursor:var(--_time-input-cursor);clip-path:inset(0px round max(0px, calc(var(--_time-input-radius) - var(--_time-input-spacing))));background:0 0;border:0;margin:0 auto;padding:0}:host([hourdigits=\"1\"]) :is(input){width:4.5ex}input::selection{background-color:color-mix(in srgb, currentColor 20%, var(--_time-input-background));color:currentColor}input::placeholder{color:currentColor;opacity:.4}input:focus{outline:none}input:focus::placeholder{opacity:.6}input[disabled]{opacity:var(--time-input-opacity-disabled,.5);pointer-events:none}[part=icon]{opacity:.9;pointer-events:none;-webkit-user-select:none;user-select:none;justify-content:center;align-self:center;font-size:90%;display:flex}@media print{:host{background:0 0;border:none}}"), p = class extends e(i(a)) {
	constructor(...e) {
		super(...e), this.styles = f, this.type = "time", this.name = "", this.compact = !1, this.disabled = !1, this.min = "00:00", this.max = "24:00", this.required = !1, this.readonly = !1, this.hourDigits = 2, this._formDisabled = !1, this._value = null, this._hasChanged = !1;
	}
	static {
		this.shadowRootOptions = {
			...a.shadowRootOptions,
			delegatesFocus: !0
		};
	}
	get value() {
		return this._value;
	}
	set value(e) {
		let t = this._value;
		this._value = e && this._normalize(e.slice(0, 5)) || null, this._hasChanged = !1, this._input && this._syncInput(), this.requestUpdate("value", t);
	}
	focus(e) {
		this._input.focus(e);
	}
	blur() {
		this._input.blur();
	}
	setCustomValidity(e) {
		this._input.setCustomValidity(e), this._syncValidity();
	}
	formResetCallback() {
		this.value = null;
	}
	formDisabledCallback(e) {
		this._formDisabled = e;
	}
	render() {
		return o`
            ${this.icon ? o`<ptc-ui-icon part="icon" name=${this.icon}></ptc-ui-icon>` : s}

            <input
                type="text"
                inputmode="numeric"
                placeholder="${"–".repeat(this.hourDigits)}:––"
                autocomplete="off"
                ?disabled=${this.disabled || this._formDisabled}
                ?readonly=${this.readonly}
                ?required=${this.required}
                @focus=${this._focus}
                @blur=${this._blur}
                @input=${this._oninput}
            />
        `;
	}
	firstUpdated() {
		this._syncInput();
	}
	updated(e) {
		super.updated(e), e.has("value") && this._validate(), e.has("hourDigits") && (this._input.value = this._displayValue(this._value)), [
			"required",
			"min",
			"max",
			"disabled",
			"readonly",
			"_formDisabled"
		].some((t) => e.has(t)) && this._validate();
	}
	_digits(e) {
		return e.replace(/[^\d]/g, "");
	}
	get formValue() {
		return this._value ?? "";
	}
	_commitForm() {
		this.internals.setFormValue(this.formValue), this._validate();
	}
	_normalize(e) {
		if (e = this._digits(e).slice(-4), !e) return null;
		let t = Number(e.slice(0, -2)), n = Number(e.slice(-2));
		return t < 24 && n < 60 || t === 24 && n === 0 ? `${t.toString().padStart(2, "0")}:${n.toString().padStart(2, "0")}:00` : null;
	}
	_displayValue(e) {
		return e ? e.slice(0, 5).slice(-3 - this.hourDigits) : "";
	}
	_syncInput() {
		this._input.value = this._displayValue(this._value), this._commitForm();
	}
	_syncValidity() {
		let e = this._input;
		e.validity.valid || !e.willValidate ? this.internals.setValidity({}) : this.internals.setValidity(e.validity, e.validationMessage, e);
	}
	_focus() {
		try {
			this._input.select();
		} catch {
			this._input.setSelectionRange(0, this._input.value.length);
		}
	}
	_blur() {
		this._input.value = this._displayValue(this._normalize(this._input.value)), this._validate(), this._hasChanged && this.dispatchEvent(new CustomEvent("change", {
			composed: !0,
			bubbles: !0,
			detail: { value: this._value }
		})), this._hasChanged = !1;
	}
	_oninput() {
		let e = this._digits(this._input.value).slice(-2 - this.hourDigits);
		this._input.value = e ? e.slice(0, -2).padStart(this.hourDigits, "–") + ":" + e.slice(-2).padStart(2, "–") : "", this._value = this._normalize(this._input.value), this._commitForm(), this._hasChanged = !0;
	}
	_validate() {
		let e = this._input.value && this._input.value.padStart(5, "0");
		e && e > this.max ? this._input.setCustomValidity(`Bitte geben Sie einen Wert kleiner oder gleich ${this.max} ein!`) : e && e < this.min ? this._input.setCustomValidity(`Bitte geben Sie einen Wert größer oder gleich ${this.min} ein!`) : this._input.setCustomValidity(""), this._syncValidity();
	}
};
n([l({ reflect: !0 }), t("design:type", Object)], p.prototype, "name", void 0), n([l({
	type: Boolean,
	reflect: !0
}), t("design:type", Object)], p.prototype, "compact", void 0), n([l({
	type: Boolean,
	reflect: !0
}), t("design:type", Object)], p.prototype, "disabled", void 0), n([l({ reflect: !0 }), t("design:type", Object)], p.prototype, "icon", void 0), n([l(), t("design:type", Object)], p.prototype, "min", void 0), n([l(), t("design:type", Object)], p.prototype, "max", void 0), n([l({ type: Boolean }), t("design:type", Object)], p.prototype, "required", void 0), n([l({
	type: Boolean,
	reflect: !0
}), t("design:type", Object)], p.prototype, "readonly", void 0), n([l({
	type: Number,
	reflect: !0
}), t("design:type", Object)], p.prototype, "hourDigits", void 0), n([
	l(),
	t("design:type", Object),
	t("design:paramtypes", [])
], p.prototype, "value", null), n([u("input"), t("design:type", typeof HTMLInputElement > "u" ? Object : HTMLInputElement)], p.prototype, "_input", void 0), n([d(), t("design:type", Object)], p.prototype, "_formDisabled", void 0), p = n([c("ptc-ui-time-input")], p);
var m = p;
//#endregion
export { m as n, p as t };

//# sourceMappingURL=time-input-B3QcNgto.js.map